import { combineReducers } from 'redux';

import { reducer as AuthReducer } from '../components/Auth';
import { reducer as LoginReducer } from '../components/LoginView';

const reducers = { ...AuthReducer, ...LoginReducer };

export default combineReducers(reducers);
